import { defineMessages } from "./define.js";

/** The lists screen: the kind tabs, a list card, the rows inside it. */
export const lists = defineMessages("lists", {
  title: { ru: "Списки", en: "Lists" },
  /* Строка под заголовком есть на каждом экране, и не ради слов: она держит
     высоту блока, а высота блока держит «+» на одном месте во всех вкладках. */
  subtitle: {
    ru: "То, что не держится в голове.",
    en: "The things that will not stay in your head.",
  },
  kindLabel: { ru: "Вид списка", en: "List type" },
  kindTodo: { ru: "Дела", en: "To-do" },
  kindShopping: { ru: "Покупки", en: "Shopping" },

  defaultTitleTodo: { ru: "Дела", en: "To-do" },
  defaultTitleShopping: { ru: "Покупки", en: "Shopping" },

  placeholderTodo: { ru: "Что нужно сделать", en: "What needs doing" },
  placeholderShopping: { ru: "Что купить", en: "What to buy" },

  newListLabelTodo: { ru: "Название списка дел", en: "Name of the to-do list" },
  newListLabelShopping: { ru: "Название списка покупок", en: "Name of the shopping list" },

  empty: {
    ru: "Здесь пока нет списков. Создайте первый — например, «{title}».",
    en: "No lists here yet. Make the first one — “{title}”, say.",
  },
  newList: { ru: "Новый список", en: "New list" },
  create: { ru: "Создать", en: "Create" },

  /* Folding a list shut. The wording of the summary is per kind, like the
     placeholders above: «осталось 2 дела» and «осталось 2 покупки» are two
     different nouns and, in Russian, two different verb endings. */
  summaryEmpty: { ru: "пусто", en: "empty" },
  summaryAllDone: { ru: "всё сделано", en: "all done" },
  remainingTodo: {
    ru: {
      one: "осталось {count} дело из {total}",
      few: "осталось {count} дела из {total}",
      many: "осталось {count} дел из {total}",
      other: "осталось {count} дела из {total}",
    },
    en: {
      one: "{count} task left of {total}",
      other: "{count} tasks left of {total}",
    },
  },
  remainingShopping: {
    ru: {
      one: "осталась {count} покупка из {total}",
      few: "осталось {count} покупки из {total}",
      many: "осталось {count} покупок из {total}",
      other: "осталось {count} покупки из {total}",
    },
    en: {
      one: "{count} item left of {total}",
      other: "{count} items left of {total}",
    },
  },

  /* Действия над самим списком, а не над его пунктами. Открываются кнопкой в
     строке заголовка — и тем же жестом влево по этой строке. */
  actions: { ru: "Действия со списком «{title}»", en: "Actions for “{title}”" },
  // Пока ряд отъехал, нажатие на него его возвращает. У жеста, который
  // открывает, нет видимой противоположности — её и называет эта подпись.
  closeActions: {
    ru: "Закрыть действия со списком «{title}»",
    en: "Close actions for “{title}”",
  },
  rename: { ru: "Переименовать", en: "Rename" },
  renameLabel: {
    ru: "Новое название списка «{title}»",
    en: "New name for “{title}”",
  },
  /* Третий ответ, которого не было у диалога удаления: он предлагал «отмена»
     или «навсегда, у обоих». Колонка под это есть с первой миграции. */
  archive: { ru: "Убрать в архив", en: "Archive" },
  unarchive: { ru: "Вернуть из архива", en: "Take out of the archive" },
  archiveHeading: {
    ru: {
      one: "Архив · {count} список",
      few: "Архив · {count} списка",
      many: "Архив · {count} списков",
      other: "Архив · {count} списка",
    },
    en: { one: "Archive · {count} list", other: "Archive · {count} lists" },
  },

  removeList: { ru: "Удалить список", en: "Delete the list" },

  /* Подтверждение удаления списка. Тяжелее, чем у одной хотелки: уходит не
     строка, а всё, что в ней лежит, и сразу у обоих. */
  removeListTitle: { ru: "Удалить «{title}»?", en: "Delete “{title}”?" },
  removeListEmpty: {
    ru: "В списке ничего нет — уйдёт только он сам.",
    en: "The list is empty — only the list itself goes.",
  },
  removeListItems: {
    ru: {
      one: "Вместе со списком исчезнет {count} пункт, включая выполненные.",
      few: "Вместе со списком исчезнут {count} пункта, включая выполненные.",
      many: "Вместе со списком исчезнут {count} пунктов, включая выполненные.",
      other: "Вместе со списком исчезнут {count} пункта, включая выполненные.",
    },
    en: {
      one: "{count} item goes with it, ticked ones included.",
      other: "{count} items go with it, ticked ones included.",
    },
  },
  removeListBoth: {
    ru: "У обоих и без возврата.",
    en: "For both of you, with no way back.",
  },

  /* Что делать с уже отмеченным. Два глагола, потому что списка два:
     недельные покупки — это тот же список, с которого сняли галочки, а дела
     выполненные значит законченные. */
  untickDone: {
    ru: {
      one: "Снять {count} отметку",
      few: "Снять {count} отметки",
      many: "Снять {count} отметок",
      other: "Снять {count} отметки",
    },
    en: { one: "Untick {count}", other: "Untick {count}" },
  },
  removeDone: {
    ru: {
      one: "Убрать {count}",
      few: "Убрать {count}",
      many: "Убрать {count}",
      other: "Убрать {count}",
    },
    en: { one: "Remove {count}", other: "Remove {count}" },
  },
  removeDoneConfirm: {
    ru: {
      one: "Точно убрать {count}?",
      few: "Точно убрать {count}?",
      many: "Точно убрать {count}?",
      other: "Точно убрать {count}?",
    },
    en: { one: "Remove {count}?", other: "Remove {count}?" },
  },

  addTo: { ru: "Добавить в «{title}»", en: "Add to “{title}”" },
  move: { ru: "Переместить «{text}»", en: "Move “{text}”" },
  remove: { ru: "Удалить «{text}»", en: "Delete “{text}”" },
  removeConfirm: {
    ru: "Точно удалить «{text}»? Нажмите ещё раз",
    en: "Delete “{text}”? Press again",
  },
  due: { ru: "до {date}", en: "by {date}" },

  /* The card that opens on a task: everything the server has always accepted
     and the row had nowhere to put. */
  details: { ru: "Подробности", en: "Details" },
  /** Names both the row that opens the card and the card itself. */
  detailsOf: { ru: "Подробности: «{text}»", en: "Details: “{text}”" },

  fieldText: { ru: "Дело", en: "Task" },
  /** То же поле в списке покупок. Всё остальное на этом экране уже разведено
      по видам — плейсхолдеры, названия, сводки, — а подпись была одна. */
  fieldItem: { ru: "Покупка", en: "Item" },
  fieldNote: { ru: "Заметка", en: "Note" },
  notePlaceholder: {
    ru: "Подробности, ссылка, что угодно",
    en: "Details, a link, anything",
  },

  fieldDue: { ru: "Срок", en: "Due date" },
  /* Час, если он есть. Срок — это ещё и то, от чего отсчитывается
     напоминание: без часа «за два часа до» означало десять утра, что бы
     человек ни имел в виду под «до 24 августа». */
  fieldDueTime: { ru: "Во сколько", en: "At what time" },
  dueClear: { ru: "Убрать срок", en: "Clear the date" },

  fieldAssignee: { ru: "Кто делает", en: "Who is doing it" },
  assigneeNobody: { ru: "Никто", en: "Nobody" },

  discuss: { ru: "Обсудить", en: "Discuss" },
  discussionCount: {
    ru: {
      one: "Обсуждение · {count} сообщение",
      few: "Обсуждение · {count} сообщения",
      many: "Обсуждение · {count} сообщений",
      other: "Обсуждение · {count} сообщения",
    },
    en: { one: "Discussion · {count} message", other: "Discussion · {count} messages" },
  },
});
